import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  loadFailed: false,
  name: '',
  email: '',
  phone: ''
}

const agencySetData = (state, { payload }) =>
  updateObject(state, { ...payload, loading: false })

const agencyLoadDataFailed = (state) =>
  updateObject(state, { loading: false, loadFailed: true })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'AGENCY/SET_DATA':
      return agencySetData(state, action)
    case 'AGENCY/LOAD_DATA_FAILED':
      return agencyLoadDataFailed(state, action)
    default:
      return state
  }
}

export default reducer
